export default "__VITE_ASSET__CjstLD50__"